export const SELECT_ALL_INDEX = -1;